export var convertSvgAttribute = function convertSvgAttribute(str) {
  return str && parseInt(str.substring(0, str.length - 2));
};